var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatadetectiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H24V14.5C24 13.5718 23.6313 12.6815 22.9749 12.0251C22.3185 11.3688 21.4283 11 20.5 11C19.5717 11 18.6815 11.3688 18.0251 12.0251C17.3687 12.6815 17 13.5718 17 14.5V15H16C15.7348 15 15.4804 15.1054 15.2929 15.2929C15.1054 15.4804 15 15.7348 15 16V21C15 21.2652 15.1054 21.5196 15.2929 21.7071C15.4804 21.8947 15.7348 22 16 22H25C25.2652 22 25.5196 21.8947 25.7071 21.7071C25.8946 21.5196 26 21.2652 26 21V16C26 15.7348 25.8946 15.4804 25.7071 15.2929C25.5196 15.1054 25.2652 15 25 15ZM19 14.5C19 14.1022 19.158 13.7207 19.4393 13.4394C19.7206 13.158 20.1022 13 20.5 13C20.8978 13 21.2794 13.158 21.5607 13.4394C21.842 13.7207 22 14.1022 22 14.5V15H19V14.5ZM24 20H17V17H24V20ZM24 4.00001H13.4137L10 0.58626C9.81496 0.399734 9.59468 0.251852 9.35198 0.151209C9.10928 0.0505661 8.84899 -0.000829299 8.58625 1.01187e-05H2C1.46957 1.01187e-05 0.960859 0.210724 0.585786 0.585796C0.210714 0.960869 0 1.46958 0 2.00001V20.0775C0.000661488 20.5872 0.203422 21.0758 0.563818 21.4362C0.924213 21.7966 1.41282 21.9993 1.9225 22H11.07C11.3352 22 11.5896 21.8947 11.7771 21.7071C11.9646 21.5196 12.07 21.2652 12.07 21C12.07 20.7348 11.9646 20.4804 11.7771 20.2929C11.5896 20.1054 11.3352 20 11.07 20H2V6.00001H24V8.00001C24 8.26523 24.1054 8.51958 24.2929 8.70712C24.4804 8.89465 24.7348 9.00001 25 9.00001C25.2652 9.00001 25.5196 8.89465 25.7071 8.70712C25.8946 8.51958 26 8.26523 26 8.00001V6.00001C26 5.46958 25.7893 4.96087 25.4142 4.5858C25.0391 4.21072 24.5304 4.00001 24 4.00001ZM8.58625 2.00001L10.5863 4.00001H2V2.00001H8.58625Z",
    fill: "url(#paint0_linear_383_9004)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_9004",
    x1: 4.38888e-8,
    y1: 22,
    x2: 21.6966,
    y2: -3.64137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A03291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatadetectiveIcon);
export default __webpack_public_path__ + "static/media/datadetective-icon.b46e6d3b63dbc5e3e0ceeff23b3b3c20.svg";
export { ForwardRef as ReactComponent };